import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as ClientApi from '~/lib/ClientApi';
import { getBusinessId } from '~/lib/Api';

let queryClient = null;
export function setPublicQueryClient(qc) {
    queryClient = qc;
}

export function clearPublicQueries() {
    queryClient?.clear();
}

export function invalidatePublicQueries() {
    queryClient?.invalidateQueries();
}

export function useFormDetailsQuery(businessId, formId) {
    const url = new URL(document.location.href);
    const params = url.searchParams.toString();

    return useQuery({
        queryKey: [
            'form',
            parseInt(businessId),
            parseInt(formId),
            JSON.stringify(params),
        ],
        queryFn: async () => {
            const data = await axios
                .get(
                    `/api/forms/${formId}?params=${encodeURIComponent(params)}`,
                )
                .then(res => res.data);
            return {
                ...data,
                formSections: (data?.sections || []).filter(
                    s => !s.section.settings?.thankyou,
                ),
            };
        },
        staleTime: 500,
    });
}

export function useSubmissionQuery(token) {
    return useQuery({
        queryKey: ['submission', token],
        queryFn: () =>
            axios.get(`/api/submission/${token}`).then(res => res.data),
    });
}

export function useGiftCertificateQuery(token) {
    return useQuery({
        queryKey: ['gift-certificate-details', token],
        queryFn: () =>
            axios.get(`/api/gift-certificate/${token}`).then(res => res.data),
    });
}

export function useClientHistoryQuery() {
    return useQuery({
        queryKey: ['client-history', ClientApi.getToken()],
        queryFn: async () => {
            if (!ClientApi.getToken()) {
                return {};
            }
            return await ClientApi.get(`/account/history`);
        },
    });
}

export function setClientHistoryQuery(data) {
    queryClient.setQueryData(
        ['client-history', ClientApi.getToken()],
        old => data,
    );
}
